import styled from "styled-components/native"
import IconButton from "../icon-button"

export const Tab = styled(IconButton)`
  flex: 1;
  height: 100%;
  padding: 0 ${(props) => props.theme.spacing.tiny}px;
`
